<template>
  <custom-page-template :vacancy="true">
    <div class="container">
      <custom-title-block :title="title" />
      <div class="vacancy-tabs">
        <div
          class="vacancy-tab"
          v-for="item in vacancy"
          :key="item.id"
          :class="{ active: item.id === activeTabIndex }"
          @click="changeTab(item.id)"
        >
          {{ item.name }}
        </div>
      </div>
      <div
        style="margin-bottom: 60px"
        v-for="item in vacancy"
        :key="item.id"
        v-show="item.id === activeTabIndex"
      >
        <custom-title-vacancy-block
          :title="item.name"
          :subtitle="item.description"
        />
        <div
          class="vacancy-imgs"
          :class="`img-${item.id}`"
          :style="`background: url(${getImageTeamPath(item.id)})`"
          alt="icon"
        />
        <div class="vacancy-content">
          <div class="vacancy-content-list">
            <div class="top" @click="toggleSection('responsibilities')">
              <h3>ОБОВʼЯЗКИ</h3>
              <img
                :class="{ rotate: isOpen.responsibilities }"
                src="@/assets/images/icons/close-black.svg"
                alt="icon"
              />
            </div>
            <ul v-show="isOpen.responsibilities">
              <li v-for="listItem in item.responsibilities" :key="listItem.id">
                {{ listItem }}
              </li>
            </ul>
          </div>
          <div class="vacancy-content-list">
            <div class="top" @click="toggleSection('requirements')">
              <h3>ВИМОГИ</h3>
              <img
                :class="{ rotate: isOpen.requirements }"
                src="@/assets/images/icons/close-black.svg"
                alt="icon"
              />
            </div>
            <ul v-show="isOpen.requirements">
              <li v-for="listItem in item.requirements" :key="listItem.id">
                {{ listItem }}
              </li>
            </ul>
          </div>
          <div class="vacancy-content-list">
            <div class="top" @click="toggleSection('conditions')">
              <h3>УМОВИ</h3>
              <img
                :class="{ rotate: isOpen.conditions }"
                src="@/assets/images/icons/close-black.svg"
                alt="icon"
              />
            </div>
            <ul v-show="isOpen.conditions">
              <li v-for="listItem in item.conditions" :key="listItem.id">
                {{ listItem }}
              </li>
            </ul>
          </div>
        </div>
        <custom-button-join />
      </div>
    </div>
  </custom-page-template>
</template>

<script>
import CustomTitleBlock from "@/components/UI/CustomTitle.vue";
import CustomTitleVacancyBlock from "@/components/UI/CustomTitleVacancy.vue";
import CustomButtonJoin from "@/components/UI/CustomButtonJoin.vue";
import CustomPageTemplate from "@/components/templates/PageTemplate.vue";

export default {
  name: "vacancy-details",
  components: {
    CustomPageTemplate,
    CustomButtonJoin,
    CustomTitleVacancyBlock,
    CustomTitleBlock,
  },
  data() {
    return {
      isOpen: {
        responsibilities: true,
        requirements: false,
        conditions: false,
      },
      title: "Обери вакансію",
      vacancy: [
        {
          id: 1,
          name: "Оператор наземних роботизованих комплексів",
          description:
            "забезпечення логістики та евакуації, " +
            "а також надання інженерної та вогневої підтримки завдяки НРК.",
          responsibilities: [
            "управління та налаштування наземних роботизованих комплексів;",
            "забезпечення стабільної роботи НРК і проведення їх планового технічного обслуговування;",
            "виконання поставлених завдань у складі підрозділу;",
            "розробка та впровадження удосконалень для наземних роботизованих комплексів;",
            "дотримання вимог безпеки під час транспортування комплексів;",
            "інформування командира відділення про виявлені несправності або пошкодження НРК;",
            "облік використаних матеріальних засобів, контроль залишків і організація своєчасного поповнення запасів.",
          ],
          requirements: [
            "розуміння технічних аспектів роботи антен, підсилювачів;",
            "досвід обслуговування та ремонту електронного обладнання;",
            "готовність працювати в зоні активних бойових дій;",
            "досвід керування безпілотними літальними апаратами (БПЛА) та робототехнікою буде перевагою;",
            "висока цифрова грамотність та здатність до навчання;",
            "придатність до військової служби за станом здоров’я.",
          ],
          conditions: [
            "служба за контрактом;",
            "супровід на етапі оформлення документів на контракт та проходження ВЛК;",
            "проходження базової загальної військової підготовки в окремому навчальному батальйоні та обов’язкової фахової підготовки перед залученням до виконання завдань;",
            "грошове забезпечення від 21 000 до 120 000 гривень в залежності від місця та періоду виконання завдань;",
            "соціальні пільги згідно діючого законодавства: щорічна відпустка — 30 календарних днів, медичне, технічне та матеріальне забезпечення;",
            "можливість долучитися до ефективної команди фахівців та здобути цінний досвід у галузі робототехніки.",
          ],
        },
        {
          id: 2,
          name: "Зовнішній пілот (оператор) БпЛА",
          description:
            "виявлення, корегування, мінування та ураження ворожих цілей.",
          responsibilities: [
            "здійснення повітряної розвідки ворожих позицій;",
            "коригування артилерійського вогню по ворожих позиціях та техніці;",
            "забезпечення супроводу груп інших підрозділів під час виконання їх завдань;",
            "знищення противника за допомогою ударних дронів та FPV;",
            "дешифрування та аналіз даних, отриманих під час розвідки;",
            "обслуговування різних видів дронів та спорядження їх для роботи.",
          ],
          requirements: [
            "цифрова грамотність, здатність та бажання навчатись новому — обов’язкові вимоги;",
            "вміння працювати з мобільними додатками та електронними пристроями;",
            "відсутність критичних проблем зі здоров’ям, які можуть вплинути на виконання завдань;",
            "готовність працювати в зоні бойових дій;",
            "висока мотивація та прагнення досягти успіху у виконанні поставлених завдань;",
            "досвід роботи з БпЛА буде перевагою;",
            "технічні навички будуть перевагою.",
          ],
          conditions: [
            "служба за контрактом;",
            "супровід на етапі оформлення документів та проходження ВЛК;",
            "проходження загального військового навчання в окремому навчальному батальйоні перед залученням до виконання завдань;",
            "грошове забезпечення від 21 000 до 120 000 гривень залежно від місця та періоду виконання завдань;",
            "соціальні пільги згідно з чинним законодавством: щорічна відпустка — 30 календарних днів, медичне, технічне та матеріальне забезпечення;",
            "можливість регулярно підвищувати кваліфікацію, проходити навчання на різних типах безпілотних літальних апаратів (БпЛА) з отриманням сертифікатів державного зразка.",
          ],
        },
        {
          id: 3,
          name: "Водій-електрик",
          description: "забезпечення переміщення екіпажу БпЛА.",
          responsibilities: [
            "керування автотранспортними засобами за будь-яких погодних умов, в будь-який час доби;",
            "якісне та безпечне доставлення особового складу підрозділу до місця виконання бойових завдань;",
            "забезпечення логістики підрозділу, перевезення вантажів різного призначення;",
            "виконання ремонту та технічного обслуговування закріпленої автомобільної техніки й електрогенераторів (дизельних, бензинових);",
            "ведення звітної документації щодо використання транспортних засобів, електрогенераторів та паливно-мастильних матеріалів;",
            "забезпечення безперебійного електропостачання підрозділу в польових умовах;",
            "виконання бойових та спеціальних завдань у складі підрозділу.",
          ],
          requirements: [
            "наявність посвідчення водія однієї або декількох категорій (В і вище);",
            "навички безаварійного водіння транспортних засобів;",
            "досвід роботи водієм буде перевагою;",
            "досвід роботи з електрогенераторами буде перевагою;",
            "базове розуміння принципів організації військового зв’язку буде перевагою;",
            "самодисципліна, бажання навчатися й вдосконалюватися;",
            "готовність працювати в зоні бойових дій;",
            "відсутність алкогольної, наркотичної, ігрової залежності;",
            "відсутність медичних протипоказань до керування транспортними засобами.",
          ],
          conditions: [
            "служба за контрактом;",
            "супровід на етапі оформлення документів та проходження ВЛК;",
            "проходження загального військового навчання в окремому навчальному батальйоні перед залученням до виконання завдань;",
            "грошове забезпечення від 21 000 до 120 000 гривень залежно від місця та періоду виконання завдань;",
            "соціальні пільги згідно з чинним законодавством: щорічна відпустка — 30 календарних днів, медичне, технічне та матеріальне забезпечення.",
          ],
        },
        {
          id: 4,
          name: "Дешифрувальник розвідувальних матеріалів",
          description:
            "аналіз, валідація та підготовка звітів на основі отриманої розвідувальної інформації.",
          responsibilities: [
            "дешифрування фото- та відеоматеріалів;",
            "нанесення отриманих та оброблених даних у визначені системи (Кропива, Дельта, інші);",
            "пошук та визначення цілей противника;",
            "консолідація розвідданих;",
            "пошук, валідація та оцінка даних;",
            "постійне вдосконалення знань щодо зовнішнього вигляду та тактики використання ворожої техніки.",
          ],
          requirements: [
            "цифрова грамотність, здатність та бажання навчатись новому — обов’язкові вимоги;",
            "вміння працювати з мобільними додатками та електронними пристроями:",
            "розвинена логіка та аналітичні здібності;",
            "здатність опрацьовувати великий обсяг інформації;",
            "відсутність критичних проблем зі здоров’ям, які можуть вплинути на виконання завдань;",
            "готовність працювати в зоні бойових дій;",
            "висока мотивація та прагнення досягти успіху у виконанні поставлених завдань.",
          ],
          conditions: [
            "служба за контрактом;",
            "супровід на етапі оформлення документів та проходження ВЛК;",
            "проходження загального військового навчання в окремому навчальному батальйоні перед залученням до виконання завдань;",
            "грошове забезпечення від 21 000 до 120 000 гривень залежно від місця та періоду виконання завдань;",
            "соціальні пільги згідно з чинним законодавством: щорічна відпустка — 30 календарних днів, медичне, технічне та матеріальне забезпечення.",
          ],
        },
        {
          id: 5,
          name: "Інженер-механік БпЛа",
          description:
            "забезпечення технічної справності безпілотних комплексів.",
          responsibilities: [
            "виконання технічного обслуговування, діагностики та ремонту БПЛА;",
            "проведення діагностики, виявлення та усунення несправностей в системах БПЛА;",
            "забезпечення готовності й надійності БПЛА перед їхнім використанням за призначенням;",
            "пайка електронних плат;",
            "встановлення й тестування нових компонентів та обладнання;",
            "виконання бойових наказів у складі підрозділу.",
          ],
          requirements: [
            "наявність досвіду з обслуговування, діагностики й ремонту електроніки, електротехніки;",
            "розуміння базових принципів схемотехніки;",
            "вміння читати електричні схеми буде перевагою;",
            "досвід керування БПЛА буде перевагою;",
            "самодисципліна, бажання навчатися й вдосконалюватися;",
            "відсутність критичних проблем зі здоров’ям, які можуть вплинути на виконання завдань;",
            "готовність працювати в зоні бойових дій.",
          ],
          conditions: [
            "служба за контрактом;",
            "супровід на етапі оформлення документів та проходження ВЛК;",
            "проходження загального військового навчання в окремому навчальному батальйоні перед залученням до виконання завдань;",
            "грошове забезпечення від 21 000 до 120 000 гривень залежно від місця та періоду виконання завдань;",
            "соціальні пільги згідно з чинним законодавством: щорічна відпустка — 30 календарних днів, медичне, технічне та матеріальне забезпечення;",
          ],
        },
        {
          id: 6,
          name: "Майстер-вибухотехнік БпЛа",
          description: "підготовка  комплексів до бойового застосування.",
          responsibilities: [
            "налаштування дронів для виконання покладених завдань;",
            "робота зі штатною номенклатурою боєприпасів;",
            "спорядження та адаптація боєприпасів для використання на FPV-дронах та системах скиду;",
            "забезпечення мінно-вибухової безпеки.",
          ],
          requirements: [
            "готовність проходити службу у зоні бойових дій;",
            "розуміння принципів детонації боєприпасів;",
            "знання основних типів боєприпасів та принципів їх роботи;",
            "цифрова грамотність та здатність та бажання навчатись новому;",
            "досвід керування БПЛА буде перевагою;",
            "відсутність критичних проблем зі здоров’ям, які можуть вплинути на виконання завдань;",
          ],
          conditions: [
            "служба за контрактом;",
            "супровід на етапі оформлення документів та проходження ВЛК;",
            "проходження загального військового навчання в окремому навчальному батальйоні перед залученням до виконання завдань;",
            "грошове забезпечення від 21 000 до 120 000 гривень залежно від місця та періоду виконання завдань;",
            "соціальні пільги згідно з чинним законодавством: щорічна відпустка — 30 календарних днів, медичне, технічне та матеріальне забезпечення;",
          ],
        },
      ],
      activeTabIndex: null,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    const idFromRoute = parseInt(this.$route.params.id);
    if (idFromRoute && this.vacancy.some((item) => item.id === idFromRoute)) {
      this.activeTabIndex = idFromRoute;
    } else {
      this.activeTabIndex = this.vacancy[0]?.id || null;
    }
  },
  methods: {
    changeTab(index) {
      this.activeTabIndex = index;
      this.$router.push("/vacancy/" + index);
    },
    toggleSection(section) {
      this.isOpen[section] = !this.isOpen[section];
    },
    getImageTeamPath(item) {
      return require(`@/assets/images/vacancy-details/${item}.jpeg`);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin-top: 210px;

  @media (max-width: 767px) {
    margin-top: 50px;
  }
}

.vacancy-tabs {
  display: flex;
  gap: 20px;
  overflow-x: scroll;
  width: 1360px;
  padding-bottom: 20px;
  margin-bottom: 100px;

  @media (max-width: 767px) {
    margin-bottom: 45px;
  }

  &::-webkit-scrollbar {
    width: 2px; /* Ширина всей полосы прокрутки */
    height: 3px;
  }

  &::-webkit-scrollbar-track {
    background: #888; /* Фон полосы */
  }

  &::-webkit-scrollbar-thumb {
    background: #1c1c1c; /* Цвет ползунка */
    width: 10px; /* Ширина ползунка */
    border-radius: 5px; /* Закругление ползунка */
    margin-left: -4px; /* Сдвиг влево, чтобы ползунок "вылезал" за полосу */
    box-shadow: inset 0 0 0 4px transparent; /* Опционально для эффекта */
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555; /* Цвет при наведении */
  }

  /* Для Firefox */
  * {
    scrollbar-width: thin; /* Тонкая полоса */
    scrollbar-color: #888 transparent; /* Цвет ползунка и фона */
  }

  @media (max-width: 767px) {
    width: unset;
  }

  .vacancy-tab {
    border: 1px solid #1c1c1c;
    padding: 16px 20px;
    min-width: 378px;
    box-sizing: border-box;
    height: 98px;
    font-family: UAF Sans HR;
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    text-transform: uppercase;
    cursor: pointer;
    display: flex;
    align-items: center;
    order: 2;

    &.active {
      background: #1c1c1c;
      color: white;
      font-family: "UAF Sans H", serif;
      order: 1;
    }
  }
}

.vacancy-imgs {
  width: 100%;
  height: 300px;
  background-size: cover !important;
  background-repeat: no-repeat !important;

  &.img-1 {
    @media (max-width: 420px) {
      background-position-x: -80px !important;
    }
    @media (max-width: 767px) {
      background-position-y: unset;
    }
    @media (min-width: 768px) {
      background-position-y: -443px !important;
    }
  }

  &.img-2,
  &.img-4 {
    @media (max-width: 414px) {
      background-position-x: -100px !important;
    }
    @media (max-width: 767px) {
      background-position-y: unset;
    }
    @media (min-width: 768px) {
      background-position-y: -170px !important;
    }
  }

  &.img-3,
  &.img-5,
  &.img-6 {
    @media (max-width: 767px) {
      background-position-y: unset;
    }
    @media (min-width: 768px) {
      background-position-y: -300px !important;
    }
  }
}

.vacancy-content {
  margin: 22px 0 44px;

  &-list {
    border-top: 1px solid #1c1c1c;
    padding: 22px 0;
    display: flex;
    flex-direction: column;
    gap: 22px;

    h3 {
      font-family: UAF Sans H, serif;
      font-weight: 600;
      font-size: 24px;
      line-height: 100%;
      letter-spacing: 0;
      text-transform: uppercase;
    }

    ul {
      margin-left: 22px;
      max-width: 1130px;
      display: flex;
      flex-direction: column;
      gap: 22px;

      li {
        font-family: UAF Sans;
        font-weight: 400;
        font-size: 24px;
        line-height: 36px;
        list-style-type: square;
        padding-left: 15px;
      }
    }
  }
}

img {
  transition: 0.3s;
  transform: rotate(135deg);
}
.rotate {
  transform: rotate(0deg);
  transition: 0.3s;
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
